import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'PhoneNumberFormat',
  pure: false
})

export class PhoneNumberFormatPipe implements PipeTransform {
  transform(phoneNumber: string): any {
    if (phoneNumber && phoneNumber.length === 10) {
      return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6)}`;
    } else if(phoneNumber && phoneNumber.length === 11){
      return `${phoneNumber.slice(0, 1)}-${phoneNumber.slice(1, 4)}-${phoneNumber.slice(4, 7)}-${phoneNumber.slice(7)}`;
    } else {
      phoneNumber = phoneNumber ? phoneNumber.trim().split(' ').join('-') : '';
      return phoneNumber;
    }
  }
}
